import React from 'react';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { SIDEBAR_CONSTANTS } from './sidebarConfig';

/**
 * Reusable sidebar menu item component
 * @param {Object} props - Component props
 * @param {string} props.route - The route path for navigation
 * @param {string} props.label - Display text for the menu item
 * @param {React.ReactNode} props.icon - Icon component to display
 * @param {boolean} props.isSelected - Whether the item is currently selected
 * @param {boolean} props.isSidebarOpen - Whether the sidebar is in open/expanded state
 * @param {function} props.onClick - Click handler function
 * @param {string} [props.className] - Additional CSS classes
 */
const SidebarItem = ({
  route,
  label,
  icon,
  isSelected,
  isSidebarOpen,
  onClick,
  className = '',
}) => {
  const getTypographyProps = (selected) => ({
    fontWeight: selected ? 'bold' : 'normal',
    color: selected ? SIDEBAR_CONSTANTS.SELECTED_COLOR : undefined,
  });

  const getSelectedStyles = (selected) => ({
    width: 'calc(100% - 16px)',
    mx: 1,
    borderRadius: '6px',
    ...(selected
      ? {
          backgroundColor: SIDEBAR_CONSTANTS.SELECTED_BACKGROUND_COLOR,
          color: SIDEBAR_CONSTANTS.SELECTED_COLOR,
          '& .MuiListItemIcon-root': {
            color: SIDEBAR_CONSTANTS.SELECTED_COLOR,
          },
        }
      : {
          color: SIDEBAR_CONSTANTS.ACTUAL_COLOR,
          '& .MuiListItemIcon-root': {
            color: SIDEBAR_CONSTANTS.ACTUAL_COLOR,
          },
        }),
  });

  return (
    <ListItem
      selected={isSelected}
      onClick={() => onClick(route)}
      className={`cursor-pointer ${className}`}
      sx={getSelectedStyles(isSelected)}
    >
      <ListItemIcon
        sx={{
          minWidth: '40px',
        }}
      >
        {icon}
      </ListItemIcon>
      {!isSidebarOpen && (
        <ListItemText
          primary={label}
          primaryTypographyProps={getTypographyProps(isSelected)}
        />
      )}
    </ListItem>
  );
};

export default SidebarItem;
